import { z } from "zod";

import { getNormalEnum } from "./pseudoEnums.js";

/** @WARN Keep in sync with packages/server/src/agents/logic-view/utils/metricCellHelpers.ts */
export const DatetimeColumnDisplayFormatTypeLiteral = z.enum([
  "PLAIN",
  /** A localized date representation with no time info */
  "DATE",
  /** ISO 8601 representation of date with no time info (YYYY-MM-DD) */
  "DATE_ISO8601",
  /** A longer localized date representation with no time info */
  "DATE_LONG",
  /** A localized time representation with no date info */
  "TIME",
  /** A localized date and time representation */
  "DATETIME",
]);
export type DatetimeColumnDisplayFormatType = z.infer<
  typeof DatetimeColumnDisplayFormatTypeLiteral
>;
export const DatetimeColumnDisplayFormatType = getNormalEnum(
  DatetimeColumnDisplayFormatTypeLiteral,
);
